/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    AGENTKB_title: "Customer support",
    AGENTKB_updatedAt: "Updated at {0} · every minute",
    AGENTKB_groupPlaceholder: "Group ID",
    AGENTKB_userPlaceholder: "User e-mail",
    AGENTKB_searchPlaceholder: "Search questions",
    AGENTKB_userAll: "All their questions",
    AGENTKB_userClear: "Remove user filter",
    AGENTKB_usersTitle: "Customer support — by user",
    AGENTKB_usersFilter: "Filter by e-mail or group ID",
    AGENTKB_usersQuestions: "Questions",
    AGENTKB_usersVotes: "Votes",
    AGENTKB_usersLast: "Last question",
    AGENTKB_usersSampled:
        "Group, votes and last question counted on the last 200 exchanges of " +
        "the period.",
    AGENTKB_usersOpenGeneral: "Open in overview",
    AGENTKB_usersClose: "Close",
    AGENTKB_articleAll: "Every question this article answered",
    AGENTKB_articleFilter: "Article: {0}",
    AGENTKB_articleClear: "Remove article filter",
    AGENTKB_kpiCache: "+ {0} cached",
    AGENTKB_helpScout: "Open the HelpScout ticket",
    AGENTKB_threadShow: "Show the whole conversation",
    AGENTKB_threadHide: "Back to this exchange",
    AGENTKB_threadLoading: "Loading…",
    AGENTKB_threadClosed: "Conversation archived on {0}",
    AGENTKB_threadOpen: "Conversation not closed",
    AGENTKB_threadSupport: "Sent to support: {0}",
    AGENTKB_conversationsTitle: "Customer support — conversations",
    AGENTKB_conversationsFirst: "First question",
    AGENTKB_conversationsTurns: "Turns",
    AGENTKB_conversationsTransfers: "Transfers",
    AGENTKB_conversationsClosed: "Archived",
    AGENTKB_conversationsNotClosed: "Not closed",
    AGENTKB_conversationsKind_all: "All",
    AGENTKB_conversationsKind_down: "With a thumbs down",
    AGENTKB_conversationsKind_sent: "Sent to support",
    AGENTKB_usageTitle: "Customer support — usage",
    AGENTKB_usageByModel: "By model",
    AGENTKB_usageByGroup: "By group",
    AGENTKB_usageModel: "Model",
    AGENTKB_usageInput: "Input",
    AGENTKB_usageOutput: "Output",
    AGENTKB_usageCache: "Cache",
    AGENTKB_usagePerQuestion: "Tokens per question",
    AGENTKB_usageNoModel: "No model (refusal, error)",
    AGENTKB_usageNoGroup: "No group",
    AGENTKB_usageGroupAll: "This group's questions",
    AGENTKB_period7: "7 days",
    AGENTKB_period30: "30 days",
    AGENTKB_period90: "90 days",
    AGENTKB_period365: "12 months",
    AGENTKB_useful: "Useful",
    AGENTKB_notUseful: "Not useful",
    AGENTKB_voteRate: "{0} votes out of {1} answers, {2} % of answers rated",
    AGENTKB_kpiQuestions: "Questions",
    AGENTKB_kpiConversations: "Conversations",
    AGENTKB_kpiSupport: "Sent to support",
    AGENTKB_kpiSupportFailed: "{0} announced but never sent",
    AGENTKB_kpiDuration: "Average response time",
    AGENTKB_kpiTokens: "Tokens used",
    AGENTKB_chartQuestions: "Questions per day",
    AGENTKB_servedTitle: "Most served articles",
    AGENTKB_rejectedTitle: "Most rejected articles",
    AGENTKB_empty: "Nothing in this period.",
    AGENTKB_sampled: "Articles counted over the last 200 exchanges of the period.",
    AGENTKB_ratingsTitle: "Answers",
    AGENTKB_filter_all: "All",
    AGENTKB_filter_up: "Useful",
    AGENTKB_filter_down: "Not useful",
    AGENTKB_filter_none: "No vote",
    AGENTKB_filter_sent: "Sent to support",
    AGENTKB_filter_failed: "Failed transfers",
    AGENTKB_columnDate: "Date",
    AGENTKB_columnUser: "User",
    AGENTKB_columnGroup: "Group",
    AGENTKB_columnQuestion: "Question",
    AGENTKB_columnArticle: "Article",
    AGENTKB_columnRating: "Rating",
    AGENTKB_columnReason: "Reason",
    AGENTKB_columnComment: "Comment",
    AGENTKB_ratingUp: "Useful",
    AGENTKB_ratingDown: "Not useful",
    AGENTKB_detailTitle: "Exchange #{0}",
    AGENTKB_close: "Close",
    AGENTKB_detailPage: "Screen",
    AGENTKB_detailSupport: "Support",
    AGENTKB_detailTechnical: "Technical",
    AGENTKB_detailAnswer: "Answer",
    AGENTKB_supportSent: "Sent on {0}",
    AGENTKB_supportFailed: "Announced, never sent"
};
